import React from 'react';
import { CircleCheckIcon, CircleXIcon } from 'lucide-react';
import { afterItems, beforeItems } from '../data/content';
export function Difference() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-48" data-mp="e3didugelir3">
      <div className="mx-auto max-w-5xl" data-id="element-49" data-mp="9cszrbcd83e">
        <div className="mx-auto max-w-3xl text-center" data-id="element-50" data-mp="8bch7bk3tea">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-51" data-mp="57xr9l719hp7">
            Une meilleure façon d&apos;entraîner le basketball
          </span>
          <h2 className="mt-5 font-display text-[2rem] font-black leading-[1.08] tracking-tight text-navy sm:text-5xl" data-id="element-52" data-mp="3rgyrl5j7ekde">
            De l&apos;Entraîneur Débordé au{' '}
            <span className="italic text-grape" data-id="element-53" data-mp="3dj0m6pmv1ya1">Guide Inspirant.</span>
          </h2>
          <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-navy/60 sm:text-base" data-id="element-54" data-mp="3ihv7by8avyxb">
            Basketball Prêt™ transforme des heures de planification en un
            système « ouvrez et entraînez ». Entrez sur le terrain avec un plan
            clair, des exercices qui fonctionnent vraiment et la confiance
            nécessaire pour faire progresser vos joueurs à chaque minute.
          </p>
        </div>

        <div className="mt-14 overflow-hidden rounded-3xl bg-white shadow-soft" data-id="element-55" data-mp="1t0p57dswv17c">
          <div className="grid md:grid-cols-2" data-id="element-56" data-mp="1t2t7xsf2pu61">
            <div className="relative bg-sand p-8 sm:p-10" data-id="element-57" data-mp="1o2x4pve7a6rj">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white text-navy/35" data-id="element-58" data-mp="10cb4gqaftqs3">
                <CircleXIcon className="h-5 w-5" aria-hidden="true" data-id="element-59" data-mp="wbr8hq1lot7j" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-navy/40" data-id="element-60" data-mp="1abik5k4n9xid">
                Le coût de repartir de zéro chaque jour
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-61" data-mp="2lpe0gw7accb6">
                AVANT
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-62" data-mp="2gq1cg84ogz70">
                La vieille méthode épuisante.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-63" data-mp="2ssucdiip7htz">
                {beforeItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-white/80 px-4 py-3 text-sm text-navy/60" data-id="element-64" data-mp="2xrxfgxf4bdzb">
                    <CircleXIcon className="mt-0.5 h-4 w-4 shrink-0 text-navy/30" aria-hidden="true" data-id="element-65" data-mp="32oxj71ohw4n9" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="relative bg-white p-8 sm:p-10" data-id="element-66" data-mp="2f0nvtvbmv8u0">
              <span className="absolute right-8 top-8 inline-flex h-9 w-9 items-center justify-center rounded-full bg-teal text-white" data-id="element-67" data-mp="2jsnz9xqwwjvc">
                <CircleCheckIcon className="h-5 w-5" aria-hidden="true" data-id="element-68" data-mp="1mbyxg41yphly" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-teal" data-id="element-69" data-mp="1rak0sccighem">
                Le système Basketball Prêt™
              </span>
              <h3 className="mt-3 max-w-[14rem] font-display text-2xl font-bold tracking-wide text-navy" data-id="element-70" data-mp="1etipqxdk5i86">
                AVEC BASKETBALL PRÊT™
              </h3>
              <p className="mt-3 max-w-xs text-xs leading-relaxed text-navy/55" data-id="element-71" data-mp="19sbjx3uz6t45">
                Votre nouvelle réalité.
              </p>
              <ul className="mt-7 space-y-3" data-id="element-72" data-mp="10t801xnzi9ol">
                {afterItems.map(item => <li key={item} className="flex items-start gap-3 rounded-2xl bg-navy-light px-4 py-3 text-sm font-medium text-navy" data-id="element-73" data-mp="w31bfxth2p6c">
                    <CircleCheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-74" data-mp="m4lma0e09pzh" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
          <p className="border-t border-navy/5 bg-cream px-6 py-4 text-center text-xs text-navy/50" data-id="element-75" data-mp="d69kd27ov5rq">
            Un système complet pour planifier moins et coacher avec plus
            d&apos;impact.
          </p>
        </div>
      </div>
    </section>;
}